// extracted by mini-css-extract-plugin
export default {"loader":"loader__AU4_kkxY","loaderInner":"loaderInner__qG_v3c3w","loaderText":"loaderText__hqXcDHsV"};